module.exports = __webpack_public_path__ + "static/media/points.19bb3ee9.svg";